module.exports = __webpack_public_path__ + "img/el-kios-03.8c0934b2.jpg";